import { createFileRoute, redirect } from "@tanstack/react-router";

import { requestedHref } from "@/api/requested-href";
import { stripLegacyBasepath } from "@/lib/route-paths";

// **Modsy's pre-2024 basepath** — `/modsy-hub/<rest>` → `/<rest>` (ADR-0019
// decision 5; research §5.1). Modsy's basepath was `/modsy-hub` until
// 2024-04-10, and 39 version share links minted before then still carry it.
// Modsy's CDN rewrites them to `/digitalops/…` with the query kept
// (`aws/apps-cdn/edge-functions/viewer-request-redirect/index.js:28-56`); that
// edge retires with modsy, so the rewrite lives here, in one hop to the root.
//
// The same rule as `/digitalops/$` — every path, the query and hash verbatim,
// always a path on this origin, `replace`. The brief 2024 `/digital-ops` name
// is not handled: modsy's edge does not rewrite it either.
export const Route = createFileRoute("/modsy-hub/$")({
  beforeLoad: ({ location }) => {
    // The visitor's own spelling of the URL, never the router's re-serialised
    // one: the query must reach the target byte for byte.
    const href = stripLegacyBasepath(requestedHref(location.href), "/modsy-hub");
    throw redirect({ href, replace: true });
  },
});
